module.exports = __webpack_public_path__ + "img/box-score-grey.a1ac02b6.svg";